import PhoneNumberInput from "components/common/PhoneNumberInput/PhoneNumberInput";
import Text from "components/common/Text/Text";
import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

export interface IPromoCode {
  code: string;
  valid?: boolean;
  invalid?: boolean;
  name?: string;
  details?: string;
}

interface IProps {
  budtenderFacing?: boolean;
  className?: string;

  promoCode: IPromoCode;
  title?: string;
  focused?: boolean;
  onFocus?(event: any): void;
}

const PromoCode = styled(
  ({
    className,
    promoCode,
    focused,
    onFocus,
    title = "Promo Code",
    budtenderFacing
  }: IProps): any => (
    <div className={className} onFocus={onFocus}>
      <Text h4 center fullWidth style={{ padding: 0, margin: 0 }}>
        {title}
      </Text>
      <PhoneNumberInput
        value={promoCode.code}
        fullWidth
        readOnly
        focused={focused}
        valid={promoCode.valid}
        invalid={promoCode.invalid}
      />
      <p>{promoCode.name}</p>
      {budtenderFacing && promoCode.details ? <p>{promoCode.details}</p> : null}
    </div>
  )
)`
  ${({ promoCode }: IProps) =>
    promoCode.valid
      ? `
    color: ${theme.color.tertiary};
  `
      : ``};

  // Invalid
  ${({ promoCode }: IProps) =>
    promoCode.invalid
      ? `
    color: ${theme.color.red};
  `
      : ``};
`;

export default PromoCode;



// WEBPACK FOOTER //
// ./src/components/PromoCode/index.tsx